import moment from "moment";

export const isSaleActive = () => {
  const now = moment();
  const startDate = moment("2021-11-25 09:00 +1300", "YYYY-MM-DD HH:mm Z");
  const endDate = moment("2021-12-01 09:00 +1300", "YYYY-MM-DD HH:mm Z");

  return now.isBetween(startDate, endDate);
};
